module.exports = __webpack_public_path__ + "img/icons-send.cd297d0e.svg";